var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrashCanDeleteAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_trash-can",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    viewBox: "0 0 292.5 292.335",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M282.054.783H203.705L197.568-9.894C195-14.4,189.678-17.5,183.533-17.5c0,0,0,.013,0,.013H108.843c-6.113,0-11.394,3.091-13.911,7.593L88.795.783H10.446C4.681.783,0,4.876,0,9.918v18.27c0,5.042,4.681,9.135,10.446,9.135H282.054c5.766,0,10.446-4.093,10.446-9.135V9.918C292.5,4.876,287.819.783,282.054.783ZM34.735,249.142c1.025,14.317,14.646,25.691,31.274,25.692H226.492c16.628,0,30.248-11.375,31.274-25.692L271.607,55.593H20.893Z",
    transform: "translate(0 17.501)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashCanDeleteAll);
export default __webpack_public_path__ + "static/media/icon_trash-can-deleteAll.47f727bcb2ae8dc9fd823cd7c132d340.svg";
export { ForwardRef as ReactComponent };